// ref. https://docs.mapbox.com/api/maps/#mapbox-styles
export const MAP_STYLES = {
  streets: "streets-v12",
  satellite: "satellite-streets-v12",
}

export const MAP_MIN_ZOOM_LEVEL = 1
export const MAP_MAX_ZOOM_LEVEL = 22

export const UNITS_FROM_CODE = {
  KM: "kilometers",
  MI: "miles",
}

export const MINIMUM_BOUNDING_BOX_DIAGONAL = 100

export const MAX_CATEGORIES = 8
